import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Star } from 'lucide-react';
interface HeroProps {
  onCtaClick: () => void;
}
export function Hero({
  onCtaClick
}: HeroProps) {
  const productImage = 'https://cdn.magicpatterns.com/uploads/wysx6AaHoCJhHxdp5eKcwd/Futbol_Explosivo_Pro_ELITE.png';
  return <section className="relative pt-16 pb-16 md:pt-24 md:pb-24 px-4 overflow-hidden" data-id="element-82">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-brand-mint/5 rounded-full blur-3xl -z-10 pointer-events-none" data-id="element-83"></div>

      <div className="max-w-5xl mx-auto text-center z-10 relative" data-id="element-84">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-85">
          <h1 className="text-4xl md:text-6xl font-display text-brand-cream mb-8 leading-[1.1] uppercase" data-id="element-86">
            Dejá de <span className="accent-underline" data-id="element-87">improvisar</span> tus
            clases de hockey.
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mb-8 relative cursor-pointer" onClick={onCtaClick} data-id="element-88">
          <motion.img whileHover={{
          scale: 1.02
        }} src={productImage} alt="Hockey Infantil 360° - Guía completa para profesores" className="mx-auto w-full max-w-2xl drop-shadow-2xl" data-id="element-89" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} data-id="element-90">
          <p className="text-lg md:text-xl text-brand-cream/90 max-w-2xl mx-auto mb-10 font-medium" data-id="element-91">
            Todo lo que necesitás para dar clases de hockey infantil más
            organizadas, dinámicas y divertidas.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-92">
          <button onClick={onCtaClick} className="group relative inline-flex items-center justify-center gap-3 px-8 py-5 bg-brand-accent hover:bg-brand-accentHover text-brand-dark font-display text-2xl uppercase tracking-wider rounded-xl shadow-[0_0_40px_rgba(180,255,0,0.4)] transition-all hover:scale-105 hover:shadow-[0_0_60px_rgba(180,255,0,0.6)]" data-id="element-93">
            QUIERO MIS CLASES LISTAS
            <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-94" />
          </button>
          <p className="mt-4 text-sm text-brand-mint flex items-center justify-center gap-2" data-id="element-95">
            <span className="w-2 h-2 rounded-full bg-brand-mint animate-pulse" data-id="element-96"></span>
            Oferta especial disponible por hoy
          </p>

          <div className="flex flex-wrap justify-center items-center gap-1 mt-8" data-id="element-97">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-accent text-brand-accent" data-id="element-98" />)}
            <span className="ml-2 text-sm font-medium text-brand-cream/80" data-id="element-99">
              +500 profesores ya lo usan
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}